import {createAsyncThunk} from '@reduxjs/toolkit';
import {integrationsApi} from 'api';
import {toastNotificationManager} from 'toast-notifications';
import {IGetAuditLogResponse} from 'models/integrations';
import {prefix} from './config';

export const fetchAuditLogThunk: any = createAsyncThunk<IGetAuditLogResponse, string>(
  `${prefix} fetchAuditLog`,
  async (integrationId: string, {dispatch, rejectWithValue}) => {
    try {
      const {parsedBody} = await integrationsApi.getAuditLog(integrationId);
      return parsedBody;
    } catch (error) {
      dispatch(toastNotificationManager.createErrorToastAction(error.parsedBody));
      return rejectWithValue({error});
    }
  }
);
